import React from 'react';
import {NavLink} from "react-router-dom";
import { RiUserSettingsLine} from "react-icons/ri";
import {TbArrowBackUp,  TbHomeSearch} from "react-icons/tb";
import {LiaCarBatterySolid} from "react-icons/lia";

const Navbar = () => {
    return (
        <React.Fragment>
            <nav className="nav nav-pills nav-justified fixed-bottom rtl max-w-lg bg-white nav-bar-app">

                <NavLink className="nav-item nav-link  " to="/home">
                    <div><TbHomeSearch  className='nav-icon' /></div>
                    <span className="text-small-2 "> جستجو و بررسی</span>
                </NavLink>
                <NavLink className="nav-item nav-link  " to="/returned-orders">
                    <div><TbArrowBackUp  className='nav-icon' /></div>
                    <span className="text-small-2 "> مرجوعی</span>
                </NavLink>

                <NavLink className="nav-item nav-link  " to="/profile">
                    <div><RiUserSettingsLine  className='nav-icon' /></div>
                    <span className="text-small-2 "> پروفایل</span>
                </NavLink>

            </nav>
        </React.Fragment>
    );
};

export default Navbar;
